module.exports = __webpack_public_path__ + "static/media/haiti-2-21-a-1310.58af4833.jpg";